module.exports = __webpack_public_path__ + "img/GitHub_Emblem_Logo.f2338ef5.svg";